import React, { useContext, useState } from 'react';
import {
  Box,
  Button,
  TextField,
} from '@mui/material';
import { DigitalCase } from '../../../redux/types';
import SurveyOptionContext from '../../../views/admin/SurveyOptionContext';

type Props = {
  surveyId: number;
  sectionId: number;
  onGenerateCases: (generatedCases: DigitalCase[]) => void;
};

const CaseGenerator: React.FC<Props> = ({
  surveyId,
  sectionId,
  onGenerateCases,
}: Props) => {
  const [caseNumbers, setCaseNumbers] = useState<number>(0);
  const [prefix, setPrefix] = useState<string>('P');
  const { disableEdit } = useContext(SurveyOptionContext);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
      && Number(event.target.value) > 0 ? Number(event.target.value) : 0;
    setCaseNumbers(value);
  };

  const handlePrefixChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setPrefix(value);
  };

  const generateCaseList = (num: number) => {
    const amount = Math.round(num);
    if (amount < 1 || amount > 40) {
      return;
    }
    const generatedCases = [...Array(amount)].map((v, i) => ({
      digitalSectionId: sectionId,
      digitalSurveyId: surveyId,
      name: `${prefix}${i + 1}`,
      sortIndex: i,
    } as DigitalCase));
    onGenerateCases(generatedCases);
  };

  return (
    <Box display="flex" gap={1} alignItems="flex-start">
      <TextField
        id="case-numbers"
        label="Number"
        type="number"
        InputLabelProps={{
          shrink: true,
        }}
        size="small"
        variant="outlined"
        onChange={handleChange}
        value={caseNumbers}
        helperText="Number must be between 1 to 40"
        fullWidth
        disabled={disableEdit}
      />
      <TextField
        id="case-prefix"
        label="Prefix"
        InputLabelProps={{
          shrink: true,
        }}
        size="small"
        variant="outlined"
        onChange={handlePrefixChange}
        value={prefix}
        helperText="Add prefix (Blank space will be considered)"
        disabled={disableEdit}
        fullWidth
      />
      <Button
        sx={{ width: 450 }}
        variant="outlined"
        onClick={() => generateCaseList(caseNumbers)}
        disabled={disableEdit}
        size="large"
      >
        Generate Cases
      </Button>
    </Box>
  );
};

export default CaseGenerator;
